export default __webpack_public_path__ + "static/media/Foto-06.97e27fbe.png";